import type { Method } from 'axios';

interface HttpMethods {
  GET: Method;
  PUT: Method;
  POST: Method;
  DELETE: Method;
  RG_PROXY_PATH: string;
}

const StringConstants: HttpMethods = {
  GET: 'get',
  PUT: 'put',
  POST: 'post',
  DELETE: 'delete',

  // Proxy paths for APIs
  RG_PROXY_PATH: 'rental-manager/growth/growth-proxy/',
};

export default StringConstants;
